import instance from "../utils/network";

export interface imagesUrl {
  coverImageUrl: string | null;
  backgroundImageUrl: string | null;
}
export function getImages(pubId: number): Promise<imagesUrl> {
  return instance.get(`/seller/pub-grade/images/${pubId}`);
}

export function editImages(
  pubId: number,
  request: FormData,
): Promise<imagesUrl> {
  return instance.put(`/seller/pub-grade/images/${pubId}`, request, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export function deleteLogoImage(id: number) {
  return instance.delete(`/seller/pub-grade/timer-logo/${id}`);
}

export function deleteBackgroundImage(id: number) {
  return instance.delete(`/seller/pub-grade/timer-background/${id}`);
}
